import { connect } from 'react-redux'

import { ChefVendorPricingAgreements } from '@components/chef/chefSections'

import services from '@services'
import coordinators from '@coordinators'
import { HandleError } from '@coordinators/composed'

import { GetCurrentHq } from '@utils'

import { VendorPricingAgreement, IndexHeadquarter } from '@types'

interface State {
  user: { lastLoggedInHq: number }
  vendorMarketVendorPricingAgreements: VendorPricingAgreement[] | null
  headquarter: { userHeadquarters: IndexHeadquarter[] }
}

const mapStateToProps = (state: State) => {
  const { userHeadquarters } = state.headquarter
  const currentHq = GetCurrentHq({
    headquarters: userHeadquarters,
    user: state.user,
  }).id

  return {
    vendorPricingAgreements: state.vendorMarketVendorPricingAgreements,
    currentHq,
  }
}

const mapDispatchToProps = () => {
  const { RestService, UIService, VendorPricingAgreementsService } = services
  const { GetVendorPricingAgreements, ShowEditVendorPricingAgreement } =
    coordinators

  const getChefVendorPricingAgreements = GetVendorPricingAgreements({
    RestService,
    VendorPricingAgreementsService,
    HandleError,
  })

  const editVendorPricingAgreement = ShowEditVendorPricingAgreement({
    UIService,
    VendorPricingAgreementsService,
  })

  return {
    getChefVendorPricingAgreements,
    editVendorPricingAgreement,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChefVendorPricingAgreements)
